// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2pMwg","additionalInfo":"AgreementModal_additionalInfo__3z6ta"};